import { create } from "zustand";
import { persist } from "zustand/middleware";

interface BusinessUnitState {
  currentBusinessUnit: string | null;
  businessUnits: Array<{ id: string; name: string }>;
  setCurrentBusinessUnit: (id: string | null) => void;
  setBusinessUnits: (units: Array<{ id: string; name: string }>) => void;
  reset: () => void;
}

export const useBusinessUnitStore = create<BusinessUnitState>()(
  persist(
    (set) => ({
      currentBusinessUnit: null,
      businessUnits: [],
      setCurrentBusinessUnit: (id: string | null) =>
        set({ currentBusinessUnit: id }),
      setBusinessUnits: (units: Array<{ id: string; name: string }>) =>
        set((state) => ({
          businessUnits: units.map((unit) => ({
            id: String(unit.id),
            name: unit.name,
          })),
          currentBusinessUnit: units.some(
            (unit) => String(unit.id) === state.currentBusinessUnit,
          )
            ? state.currentBusinessUnit
            : units.length
              ? String(units[0].id)
              : null,
        })),
      reset: () => {
        set({ currentBusinessUnit: null, businessUnits: [] });
        useBusinessUnitStore.persist.clearStorage();
      },
    }),
    {
      name: "pw-business-units",
      partialize: (state) => ({
        currentBusinessUnit: state.currentBusinessUnit,
        businessUnits: state.businessUnits,
      }),
    },
  ),
);
